import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function DataTable({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table" size="small">
        <TableHead
          sx={{
            backgroundColor: "black",
          }}
        >
          <TableRow>
            {!process.env.NODE_ENV || process.env.NODE_ENV === "development" ? (
              <TableCell>ID</TableCell>
            ) : (
              <></>
            )}
            <TableCell align="center">Title</TableCell>
            <TableCell align="center">Sectors</TableCell>
            <TableCell align="center">Nature of Transaction</TableCell>
            <TableCell align="center">Determination By CAK</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((transaction) => (
            <TableRow key={transaction["no"]}>
              {!process.env.NODE_ENV ||
              process.env.NODE_ENV === "development" ? (
                <TableCell component="th" scope="row">
                  {transaction["no"]}
                </TableCell>
              ) : (
                <></>
              )}

              <TableCell align="center">{transaction["title"]}</TableCell>
              <TableCell align="center">{transaction["sectors"]}</TableCell>
              <TableCell align="center">
                {transaction["nature-of-transaction"]}
              </TableCell>
              <TableCell align="center">
                {transaction["determination"]}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
